"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUserHeightOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.user-height_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "user-height_outline_svg__transparent_box" },
            React.createElement("path", { className: "user-height_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "user-height_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "user-height_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M28 7V5h-5v22h5v-2h-3v-3h2v-2h-2v-3h2v-2h-2v-3h2v-2h-2V7h3zM12 14a3.82 3.82 0 002.84-1A4.67 4.67 0 0016 9.5C16 5.59 13.49 5 12 5a3.91 3.91 0 00-2.85 1A4.67 4.67 0 008 9.5c0 3.91 2.5 4.5 4 4.5zm-1.44-6.56A2 2 0 0112 7c1.23 0 2 .42 2 2.5a2.94 2.94 0 01-.56 2.06A2 2 0 0112 12c-1.23 0-2-.42-2-2.5a2.92 2.92 0 01.56-2.06zM12 16a13.61 13.61 0 00-7.59 2.21l-.41.3V27h16v-8.49l-.41-.3A13.61 13.61 0 0012 16zm6 9H6v-5.43A12 12 0 0112 18a12.24 12.24 0 016 1.57z" }))));
}
exports.default = SvgUserHeightOutline;
//# sourceMappingURL=UserHeightOutline.js.map